// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ChartBar(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChartBar" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M13 4H16V20H13V4Z", fill: "currentColor" }),
            React.createElement("path", { d: "M11 10H8V20H11V10Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6 13H3V20H6V13Z", fill: "currentColor" }),
            React.createElement("path", { d: "M21 8H18V20H21V8Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ChartBar.js.map